@let _valueFieldName = valueFieldName();
@let _viewValueFieldName = viewValueFieldName();
<mat-card appearance="outlined" [style.width]="width()" class="se-ui-combo-content mat-card-shadow">
    <div class="fix-editor">
        <mat-form-field
            class="ag-row fix-mat-form combo-cell-editor"
            hintLabel="{{ 'se-ui-datagrid_combo_cell_editor_hint' | translate }}"
        >
            <mat-select
                panelClass="ag-custom-component-popup"
                [formControl]="comboFormControl()"
                [compareWith]="compareWithFn"
                [multiple]="multi()"
                [focusSelectOn]="cellReady()"
            >
                @for (item of dataSource(); track item) {
                    <mat-option [value]="_valueFieldName ? item[_valueFieldName] : item">
                        {{ _viewValueFieldName ? item[_viewValueFieldName] : item }}
                    </mat-option>
                }
            </mat-select>
            @if (isResettable() && !multi()) {
                <button
                    class="icon-button-close se-button-no-ripple"
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="onCleanCombo($event)"
                >
                    <mat-icon class="icon-close">close</mat-icon>
                </button>
            }
            @if (comboFormControl().hasError("required")) {
                <mat-error>
                    {{ "se-ui-datagrid_required_value_constraint" | translate }}
                </mat-error>
            }
        </mat-form-field>
    </div>
</mat-card>
